module.exports = __webpack_public_path__ + "media/images/prestaciones/epoc-1a532dc7b1e810274148adebf540ebdd.svg";